import { $ } from "@/common/Axios";

export default {
  /**
   * 用户家庭成员表
   */
  userFamily_resetPassword: {
    /*
     * 重置密码
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/user/userFamily/resetPassword", p, c),
  },
  userFamily_changePassword: {
    /*
     * 修改密码（需家长登录）
     * phone 手机号 (string query required)
     * password 原密码 (string query required)
     * newPassword 新密码 (string query required)
     */
    put: (p, c) => $.put("/api/ums/user/userFamily/changePassword", p, c),
  },
  userFamily: {
    /*
     * 添加
     * family  ( query required)
     */
    post: (p, c) => $.post("/api/ums/user/userFamily", p, c),
  },
  userFamily_uploadForContinue: {
    /*
     * 导入家长信息
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/ums/user/userFamily/uploadForContinue", p, c),
  },
  userFamily_signIn: {
    /*
     * 登录
     * platform 平台:成考宝典，专升本，华博特园丁，职教智慧云 (string query required)
     * phone 手机号 (string query required)
     * password 密码 (string query required)
     * userId 用户id (integer query required)
     */
    post: (p, c) => $.post("/api/ums/user/userFamily/signIn", p, c),
  },
  userFamily_saveForClient: {
    /*
     * 添加
     * family  ( query required)
     */
    post: (p, c) => $.post("/api/ums/user/userFamily/saveForClient", p, c),
  },
  userFamily_list: {
    /*
     * 列表
     * userId 用户id (integer query )
     */
    get: (p, c) => $.get("/api/ums/user/userFamily/list", p, c),
  },
  userFamily_listSimpleUser: {
    /*
     * 学生账号列表
     * phone 手机号 (string query required)
     */
    get: (p, c) => $.get("/api/ums/user/userFamily/listSimpleUser", p, c),
  },
  userFamily_exportModuleForContinue: {
    /*
     * 家长信息导入模板
     */
    get: (p, c) =>
      $.get("/api/ums/user/userFamily/exportModuleForContinue", p, c),
  },

  /**
   * 用户
   */
  user_updateUserSignature: {
    /*
     * 更新学生签名
     * userId userId (integer query required)
     * signatureUrl 签名地址 (string query required)
     */
    put: (p, c) => $.put("/api/ums/user/user/updateUserSignature", p, c),
  },
  user_updateUserSignatureForClient: {
    /*
     * 更新学生签名
     * userId userId (integer query required)
     * signatureUrl 签名地址 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ums/user/user/updateUserSignatureForClient", p, c),
  },
  user_updateSelf: {
    /*
     * 编辑个人信息
     * userSignInfo  ( query required)
     */
    put: (p, c) => $.put("/api/ums/user/user/updateSelf", p, c),
  },
  user_searchByNo: {
    /*
     * 根据身份证号查询是否已签名
     * idCardNo 身份证号码 (string query required)
     */
    put: (p, c) => $.put("/api/ums/user/user/searchByNo", p, c),
  },
  user_clearDevice: {
    /*
     * 清除绑定设备
     * userId 用户id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/user/user/clearDevice", p, c),
  },
  user_changePassword: {
    /*
     * 修改密码
     * oldPassword 旧密码 (string query )
     * password 密码 (string query )
     */
    put: (p, c) => $.put("/api/ums/user/user/changePassword", p, c),
  },
  user_ydChangeSchoolRoll: {
    /*
     * 切换学籍-园丁小程序专用
     * schoolRollId 新合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/ums/user/user/ydChangeSchoolRoll", p, c),
  },
  user_signIn: {
    /*
     * 登录
     * platform 平台:成考宝典，专升本，华博特园丁，职教智慧云 (string query required)
     * phone 手机号 (string query )
     * password 密码 (string query )
     * type 类型（微信）：公众号,小程序,APP (string query )
     * signCode 登录码 (string query )
     * os 操作系统 (string query )
     * deviceId 设备id (string query )
     */
    post: (p, c) => $.post("/api/ums/user/user/signIn", p, c),
  },
  user_signInYD: {
    /*
     * 登录-园丁小程序专用
     * type 类型（微信）：公众号,小程序,APP (string query )
     * signCode 登录码 (string query )
     */
    post: (p, c) => $.post("/api/ums/user/user/signInYD", p, c),
  },
  user_resetPassword: {
    /*
     * 重置密码、解冻账号
     * userId userId (integer query required)
     */
    post: (p, c) => $.post("/api/ums/user/user/resetPassword", p, c),
  },
  user_batchUpdatePhone: {
    /*
     * 批量修改手机号
     * file file (string body required)
     */
    post: (p, c) => $.post("/api/ums/user/user/batchUpdatePhone", p, c),
  },
  user_signInfo: {
    /*
     * 登录信息
     */
    get: (p, c) => $.get("/api/ums/user/user/signInfo", p, c),
  },
  user_getNameAndIdCardNoByUserId: {
    /*
     * 根据用户ID获取手机号、姓名、身份证
     * userId 用户ID (integer query required)
     * getPhone 是否返回手机号(1是 0否) (integer query )
     */
    get: (p, c) => $.get("/api/ums/user/user/getNameAndIdCardNoByUserId", p, c),
  },
  user_checkBindContinue: {
    /*
     * 检查是否已绑定职教通账号，未绑定报错
     * phone phone (string query required)
     */
    get: (p, c) => $.get("/api/ums/user/user/checkBindContinue", p, c),
  },
  user_signOut: {
    /*
     * 退出登录
     */
    delete: (p, c) => $.delete("/api/ums/user/user/signOut", p, c),
  },
  user_logOut: {
    /*
     * 注销
     */
    delete: (p, c) => $.delete("/api/ums/user/user/logOut", p, c),
  },
  user_clearYdCache: {
    /*
     * 清除缓存
     */
    delete: (p, c) => $.delete("/api/ums/user/user/clearYdCache", p, c),
  },

  /**
   * 用户实名信息
   */
  realName_updateSelfPhoto: {
    /*
     * 批量更新个人照
     * idCardNo 身份证号码 (string query required)
     * photo 个人照地址 (string query required)
     */
    put: (p, c) => $.put("/api/ums/user/realName/updateSelfPhoto", p, c),
  },
  realName_updateCardPhoto: {
    /*
     * 根据身份证号码更新正反面照片和个人照
     * idCardNo 身份证号码 (string query required)
     * frontPhoto 身份证正面照片 (string query )
     * backPhoto 身份证反面照片 (string query )
     * photo 个人照 (string query )
     */
    put: (p, c) => $.put("/api/ums/user/realName/updateCardPhoto", p, c),
  },
  realName_getNamePhoneByIdCardNo: {
    /*
     * 根据身份证号码获取姓名和手机号
     * idCardNo 身份证号码 (string query required)
     */
    put: (p, c) => $.put("/api/ums/user/realName/getNamePhoneByIdCardNo", p, c),
  },

  /**
   * 新生注册
   */
  enrollSelf_saveSingleResumeInfo: {
    /*
     * 单条添加编辑履历信息
     * userId userId (integer query )
     * resumeInfoId 记录ID，编辑传入，不传默认为新增 (integer query )
     * name 学校名称 (string query required)
     * certifier 证明人（建议填写班主任） (string query required)
     * startTime 履历开始时间 (string query required)
     * endTime 履历结束时间 (string query required)
     * otherInfo 其他信息 (string query required)
     */
    put: (p, c) => $.put("/api/ums/user/enrollSelf/saveSingleResumeInfo", p, c),
  },
  enrollSelf_saveRealNameInfo: {
    /*
     * 编辑身份证照片、民族, 为空方可填入
     * nation 民族 (string query )
     * idCardFrontPhoto 身份证正面照 (string query )
     * idCardBackPhoto 身份证背面照 (string query )
     */
    put: (p, c) => $.put("/api/ums/user/enrollSelf/saveRealNameInfo", p, c),
  },
  enrollSelf_listResumeInfo: {
    /*
     * 查询学生履历信息
     * userId userId (integer query )
     */
    get: (p, c) => $.get("/api/ums/user/enrollSelf/listResumeInfo", p, c),
  },
  enrollSelf_listResumeInfoBySchoolRollId: {
    /*
     * 根据合同编号查询履历信息
     * schoolRollId schoolRollId (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ums/user/enrollSelf/listResumeInfoBySchoolRollId", p, c),
  },
  enrollSelf_remove: {
    /*
     * 删除
     * id 履历或家庭成员列表返回的ID (integer query required)
     * type 类型 1家庭成员 2履历 (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/user/enrollSelf/remove", p, c),
  },

  /**
   * 修改手机号
   */
  changePhone: {
    /*
     * 编辑
     * id id (integer query required)
     * newPhone 新手机号 (string query required)
     * remark 备注 (string query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/user/changePhone", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/user/changePhone", p, c),
  },
  changePhone_sync: {
    /*
     * 同步
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/user/changePhone/sync", p, c),
  },
  changePhone_checkVerify: {
    /*
     * 验证手机号验证码
     * id id (integer query required)
     * newPhone 新手机号 (string query required)
     * verifyCode 备注 (string query required)
     */
    put: (p, c) => $.put("/api/ums/user/changePhone/checkVerify", p, c),
  },
  changePhone_apply: {
    /*
     * 申请
     * userId 用户id (integer query required)
     * newPhone 新手机号 (string query required)
     * remark 备注 (string query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     */
    post: (p, c) => $.post("/api/ums/user/changePhone/apply", p, c),
  },
  changePhone_listByUserId: {
    /*
     * 列表
     * userId 用户id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/user/changePhone/listByUserId", p, c),
  },
  changePhone_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/user/changePhone/details", p, c),
  },

  /**
   * 用户基本信息
   */
  baseInfo_openCkbd: {
    /*
     * 开启成考宝典试用
     * userId 用户id (integer query required)
     */
    put: (p, c) => $.put("/api/ums/user/baseInfo/openCkbd", p, c),
  },

  /**
   * 教师管理
   */
  adultTeacher_update: {
    /*
     * 编辑
     * id id (integer query required)
     * idCardNo 身份证 (string query )
     * graduatedSchool 毕业院校 (string query )
     * graduatedMajor 毕业专业 (string query )
     * educationLevel 学历（无，专科，本科，硕士，博士） (string query )
     * schoolingName 任职院校 (string query )
     * jobTitle 职称（无 专业技术人员 讲师 副教授 教授） (string query )
     * teachCourse 可授课课程名称 (string query )
     * thesisTeach 是否可以指导论文（1是0否） (string query )
     * credentialType 资格证书类型( 高校教师资格证、中学教师资格证 、职业资格证书， 其他， 无) (string query )
     * credentialUrl 资格证书地址 (string query )
     * openingBank 开户行 (string query )
     * accountNo 银行卡账号 (string query )
     * politics 政治面貌 (string query )
     * qq qq (string query )
     * email 邮箱 (string query )
     * educationCredentialUrl 毕业证书地址 (string query )
     * teacherCertificationNo 教师资格证编号 (string query )
     * resumeInfo 履历信息 (string query )
     */
    put: (p, c) => $.put("/api/ums/user/adultTeacher/update", p, c),
  },
  adultTeacher_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ums/user/adultTeacher/upload", p, c),
  },
  adultTeacher_setPayStandard: {
    /*
     * 设置薪酬
     * id id (integer query required)
     * amount 100元/小时 (integer query )
     */
    post: (p, c) => $.post("/api/ums/user/adultTeacher/setPayStandard", p, c),
  },
  adultTeacher_save: {
    /*
     * 添加
     * name 姓名 (string query required)
     * phone 手机号 (string query required)
     * position 职位（下拉） (string query required)
     * idCardNo 身份证号 (string query )
     * graduatedSchool 毕业院校 (string query )
     * graduatedMajor 毕业专业 (string query )
     * educationLevel 学历（无，专科，本科，硕士，博士） (string query )
     * schoolingName 任职院校 (string query )
     * jobTitle 职称（无 专业技术人员 讲师 副教授 教授） (string query )
     * teachCourse 可授课课程名称 (string query )
     * thesisTeach 是否可以指导论文（是或否） (string query )
     * credentialType 资格证书类型( 高校教师资格证、中学教师资格证 、职业资格证书， 其他， 无) (string query )
     * credentialUrl 资格证书地址 (string query )
     * openingBank 开户行 (string query )
     * accountNo 银行卡号 (string query )
     * politics 政治面貌 (string query )
     * qq qq (string query )
     * email 邮箱 (string query )
     * educationCredentialUrl 学历证书地址 (string query )
     * teacherCertificationNo 教师资格证编号 (string query )
     * resumeInfo 履历信息 (string query )
     */
    post: (p, c) => $.post("/api/ums/user/adultTeacher/save", p, c),
  },
  adultTeacher_teacherContactInfo: {
    /*
     * 查看老师联系方式
     * teacherId id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/user/adultTeacher/teacherContactInfo", p, c),
  },
  adultTeacher_list: {
    /*
     * 教师列表
     */
    get: (p, c) => $.get("/api/ums/user/adultTeacher/list", p, c),
  },
  adultTeacher_listSimple: {
    /*
     * 简单教师列表
     * ableStatus 启用禁用 (string query required)
     * major 专业 (string query required)
     * name 姓名 (string query required)
     */
    get: (p, c) => $.get("/api/ums/user/adultTeacher/listSimple", p, c),
  },
  adultTeacher_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ums/user/adultTeacher/export", p, c),
  },
  adultTeacher_detail: {
    /*
     * 教师详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ums/user/adultTeacher/detail", p, c),
  },

  /**
   * 收货地址
   */
  address: {
    /*
     * 添加
     * address  ( query required)
     */
    post: (p, c) => $.post("/api/ums/user/address", p, c),

    /*
     * 删除
     * id 行ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ums/user/address", p, c),
  },
  address_listForClient: {
    /*
     * 我的收获地址列表
     */
    get: (p, c) => $.get("/api/ums/user/address/listForClient", p, c),
  },
  address_details: {
    /*
     * 地址详情
     * id 行ID (integer query required)
     */
    get: (p, c) => $.get("/api/ums/user/address/details", p, c),
  },
};
